module.exports = __webpack_public_path__ + "static/media/profileImg.76ca7124.jpg";